module.exports = __webpack_public_path__ + "img/duopingtai_xiaochengxu.e50f0067.png";